import Vue from 'vue'
import App from './App.vue'
import router from './router'
import configPlugin from '@/config'
import moment from 'moment'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false
Vue.use(configPlugin)

Vue.filter('formatDate', function (value) {
  if (value) {
    var m = moment(String(value))
    moment.locale('es')
    m.locale(false)
    return m.format('MMMM [de] YYYY')
  }
})

const loadimage = require('./assets/loading.gif')
const errorimage = require('./assets/error.gif')

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
